import firebase from './firebase';
import 'firebase/compat/auth';

const auth = firebase.auth();

//if (process.env.NODE_ENV === 'development') {
//    firebase.auth().useEmulator('http://localhost:9099');
//    console.log('AUTENTICACIÓN DE EMULADOR');
//}

export default auth;
